var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"kus-slider-container",class:_vm.classes,attrs:{"shrink":""},on:{"mousedown":function($event){$event.preventDefault();return _vm.start.apply(null, arguments)}}},[_c('div',{staticClass:"kus-slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }